import { render } from "./CatalogoConFiltroClienti.vue?vue&type=template&id=1f766e2a&scoped=true"
import script from "./CatalogoConFiltroClienti.vue?vue&type=script&lang=js"
export * from "./CatalogoConFiltroClienti.vue?vue&type=script&lang=js"

import "./CatalogoConFiltroClienti.vue?vue&type=style&index=0&id=1f766e2a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f766e2a"]])

export default __exports__